import {
  EmbeddedSheetPageClose,
  SheetPageBody,
  SheetPageTitle,
} from "@/components/ui/sheet-page"
import { useShowProps } from "./page-props"
import Flash from "@/components/ui/flash"
import { MailPlus } from "lucide-react"
import { useTranslation } from "react-i18next"

export default function Page() {
  const { t } = useTranslation(["invitations"])
  const {
    invitation: { teacher_name },
  } = useShowProps()

  return (
    <SheetPageBody>
      <SheetPageTitle icon={MailPlus}>
        {t("invitations:invitation.title", { teacher_name })}
      </SheetPageTitle>
      <div className="flex flex-col gap-6 p-6">
        <Flash />
        <EmbeddedSheetPageClose>Close</EmbeddedSheetPageClose>
      </div>
    </SheetPageBody>
  )
}
